var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-games-item"},[_vm._v("\n  "+_vm._s(_vm.data.awayTeam.abbreviation)+" @ "+_vm._s(_vm.data.homeTeam.abbreviation)+"\n  "+_vm._s(_vm.gameDate)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }